// Modules
import React, { FC, ReactElement, useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';

// Screens
import EventScreen from './screens/event.screen';
import EventDetailScreen from './screens/event-details.screen';
// Theme
import { theme } from './styles/theme';
import { GlobalStyles } from './styles/root.styles';
import { Store } from './types/store';

const App: FC = (): ReactElement => {
	const direction = useSelector((state: Store) => state.common.dir);

	useEffect(()=>{
		if(!Object.keys(window).includes('dataLayer')) {
			(window as any)['dataLayer'] = []
		}
	 },[]);
	 
	return (
		<ThemeProvider
			theme={{ ...theme, layout: { ...theme.layout, dir: direction } }}
		>
			<GlobalStyles />
			<Switch>
				<Route
					exact
					path="/"
					render={() => (
						<Redirect to={`/events`} />
					)}
				/>
				<Route path={`/:lang/events/past/:organizingUnit`} component={EventScreen} />
				<Route path={`/events/past/:organizingUnit`} component={EventScreen} />
				<Route path={`/:lang/events/past`} component={EventScreen} />
				<Route path={`/events/past`} component={EventScreen} />
				<Route path={`/:lang/events/:organizingUnit`} component={EventScreen} />
				<Route path={`/events/:organizingUnit`} component={EventScreen} />
				<Route path={`/:domainUnit/our-events`} component={EventScreen} />
				<Route path={`/:domainUnit/our-events/past`} component={EventScreen} />
				<Route path={`/:lang/:domainUnit/our-events`} component={EventScreen} />
				<Route path={`/:lang/:domainUnit/our-events/past`} component={EventScreen} />
				<Route path={`/:lang/events`} component={EventScreen} />
				<Route path={`/events`} component={EventScreen} />
				<Route path={`/:lang/event/:eventId`} component={EventDetailScreen} />
				<Route path={`/event/:eventId`} component={EventDetailScreen} />
				<Route path={`/:domainUnit/our-event/:eventId`} component={EventDetailScreen} />
				<Route path={`/:lang/:domainUnit/our-event/:eventId`} component={EventDetailScreen} />
			</Switch>
		</ThemeProvider>
	);
};

export default App;
